export default {"src":"/_next/static/media/slice-f4.2a767854.svg","height":10350,"width":3100};